module.exports = __webpack_public_path__ + "img/Chapel-t-24685-029-474x317.ad7a5595.jpg";